import PropTypes from 'prop-types'
import React from 'react'
import UserRowAvatar from './UserRow.Avatar'
import UserRowBio from './UserRow.Bio'
import UserRowFullName from './UserRow.FullName'
import UserRowName from './UserRow.Name'
import UserRowWebsite from './UserRow.Website'
import { STYLES_FONT_SIZE } from 'modules/styles/constants/index.cjs'
import { View } from 'components/View'
import { createSelector } from 'reselect'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { connect } from 'react-redux'

class UserRow extends React.Component {
  render () {
    const isSmallScreen = this.props.isSmallScreen
    return (
      <View
        style={{
          flexDirection: isSmallScreen
            ? View.DIRECTION.COLUMN
            : View.DIRECTION.ROW,
          alignItems: isSmallScreen
            ? View.ALIGN.CENTER
            : View.ALIGN.START,
          justifyContent: isSmallScreen
            ? View.JUSTIFY.CENTER
            : View.JUSTIFY.START,
          width: '100%'
        }}
      >
        {this.props.children}
      </View>
    )
  }
}

UserRow.ALIGN = View.ALIGN
UserRow.Avatar = UserRowAvatar
UserRow.Bio = UserRowBio
UserRow.FullName = UserRowFullName
UserRow.Name = UserRowName
UserRow.FONT_SIZE = STYLES_FONT_SIZE
UserRow.Website = UserRowWebsite

UserRow.propTypes = {
  fontSize: PropTypes.oneOf(
    Object.values(UserRow.FONT_SIZE)
  ),
  isSmallScreen: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
}

const select = () => createSelector(
  isSmallScreenViewportSelect,
  (isSmallScreen) => ({
    isSmallScreen
  })
)

export default connect(select)(UserRow)
